var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRupees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0026 23.6663C18.4459 23.6663 23.6693 18.4429 23.6693 11.9997C23.6693 5.55635 18.4459 0.333008 12.0026 0.333008C5.55928 0.333008 0.335938 5.55635 0.335938 11.9997C0.335938 18.4429 5.55928 23.6663 12.0026 23.6663ZM13.753 7.33301C14.135 7.84174 14.4089 8.43649 14.5401 9.08301H16.6693V10.833H14.5401C14.1347 12.83 12.3692 14.333 10.2526 14.333H10.0318L14.3713 18.6727L13.1339 19.91L7.33594 14.1122V12.583H10.2526C11.3956 12.583 12.3679 11.8526 12.7283 10.833H7.33594V9.08301H12.7283C12.3679 8.06347 11.3956 7.33301 10.2526 7.33301H7.33594V5.58301H16.6693V7.33301H13.753Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupees);
export default __webpack_public_path__ + "static/media/rupees.01eb73da4e63aad31ecb953e77905cbb.svg";
export { ForwardRef as ReactComponent };